import styled from "styled-components"

export const Header = styled.div`
  font-size: ${({ size }) => size || "54px"};
  color: #20ae84;
  margin: ${({ margin }) => margin};
  @media screen and (max-width: 640px) {
    font-size: 24px;
  }
`
export const PageHeader = styled.div`
  font-size: ${({ size }) => size || "54px"};
  margin: ${({ margin }) => margin};
  @media screen and (max-width: 640px) {
    font-size: 24px;
    margin: 20px 0;
  }
`
export const Line = styled.hr`
  width: 82px;
  padding: 1px 0px;
  background-color: #1d395a;
  margin-top: 30px;
  margin-bottom: 34px;
  @media screen and (max-width: 640px) {
    display: none;
  }
`
export const Card = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 418px;
  height: 207px;
  /* background: #ffffff; */
  border: 1px solid #dddddd;
  border-radius: 12px;
  margin: 60px 30px 130px 0;
  position: relative;
  overflow: hidden;
  /* color: #000; */
  .about_card__title {
    font-size: 24px;
  }
  @media screen and (max-width: 640px) {
    /* width: 170px; */
    width: 100%;
    height: 100px;
    margin: 10px;
    .about_card__title {
      font-size: 16px;
      margin: 0;
    }
  }
`

export const Shape = styled.div`
  width: 199px;
  height: 199px;
  position: absolute;
  background: #20ae84;
  border: none;
  border-radius: 100%;
  top: -100px;
  left: -100px;
  @media screen and (max-width: 640px) {
    display: none;
  }
`
